import React, { Component } from 'react';

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import AnalyticsListener from 'components/analytics/analyticsListener';

// merchant imports
import MerchantLayout from 'layouts/MerchantLayout';
import Merchants from 'pages/Merchant/merchants';
import MerchantSignIn from 'pages/Merchant/signin';
import MerchantSuccess from 'pages/Merchant/success';

// admin imports
import AdminLayout from 'layouts/AdminLayout';
import MerchantVitals from 'pages/Admin/MerchantVitals/merchantVitals';
import Businesses from 'pages/Admin/Business/Businesses/businesses';
import BusinessEditor from 'pages/Admin/Business/Businesses/businessEditor';

import UserInspector from 'pages/Admin/UserInspector/userInspector';
import VerifiedPhoneNumbers from 'pages/Admin/VerifiedPhoneNumbers/verifiedPhoneNumbers';

class BambooRouter extends Component {
  render() {
    // Allow passing a layout to specific components to distinguish different parts of the project
    // e.g. - Business, Merchant, Admin, Join
    const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
      <Route {...rest} render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )} />
    );

    return (
      <Router>
        <AnalyticsListener>
          <Switch>
            {/* /admin routes */}
            <AppRoute exact path='/admin/merchant-vitals' layout={AdminLayout} component={MerchantVitals} />
            <AppRoute exact path="/admin/businesses" layout={AdminLayout} component={Businesses} />
            <AppRoute exact path="/admin/businesses/:businessId" layout={AdminLayout} component={BusinessEditor} />

            <AppRoute exact path="/admin/user/:userId" layout={AdminLayout} component={UserInspector} />
            <AppRoute exact path="/admin/phoneNumbers" layout={AdminLayout} component={VerifiedPhoneNumbers} />
            
            {/* /merchant routes */}
            <AppRoute exact path='/merchant' layout={MerchantLayout} component={Merchants} />
            <AppRoute exact path='/merchant/signup' layout={MerchantLayout} component={Merchants} />
            <Redirect exact from='/merchant/signin' to='/merchant/login' />
            <AppRoute exact path='/merchant/login' layout={MerchantLayout} component={MerchantSignIn} />
            <AppRoute exact path='/merchant/success' layout={MerchantLayout} component={MerchantSuccess} />

            {/* Legacy redirects */}
            <Route exact path='/business/people/plans' component={() => window.location = 'https://business.bamboo.app/dashboard/plans'} />
            <Route exact path='/business/people' component={() => window.location = 'https://business.bamboo.app/dashboard/plans'} />
            <Route exact path='/business/signup/createAccount' component={() => window.location = 'https://business.bamboo.app/signup/create-account'} />
            <Redirect exact path='/admin/merchantVitals' to='/admin/merchant-vitals' />

            {/* /business route redirects to business.bamboo.app */}
            <Route exact path='/business/signin' component={() => window.location = 'https://business.bamboo.app/login'} />
            <Route exact path='/business/login' component={() => window.location = 'https://business.bamboo.app/login'} />

            <Route exact path='/business/signup' component={() => window.location = 'https://business.bamboo.app/signup'} />
            <Route exact path="/business/signup/begin" component={() => window.location = 'https://business.bamboo.app/signup'} />
            <Route exact path="/business/signup/create-account" component={() => window.location = 'https://business.bamboo.app/signup/create-account'} />
            <Route exact path="/business/signup/:businessId/add-payment" component={() => window.location = 'https://business.bamboo.app/signup/:businessId/add-payment'} />
            <Route exact path="/business/signup/link-account/:id" component={() => window.location = 'https://business.bamboo.app/signup/link-account/:id'} />

            {/* All auth'd paths redirect to new business product log-in page */}
            <Route path='/business/:businessId' component={() => window.location = `https://business.bamboo.app/login`} />

            {/* Catch-all 404s */}
            <Route exact path='/admin/**' component={() => window.location = 'https://bambooapp.ie/404'} />
            <Route exact path='/join/**' component={() => window.location = 'https://bambooapp.ie/404'} />

            <Route exact path='/' component={() => window.location = '/admin'} />
            <Route exact path='**' component={() => window.location = 'https://bambooapp.ie/404'} />
          </Switch>
        </AnalyticsListener>
      </Router>
    );
  }
}

export default BambooRouter;
